import React from 'react';
import { useDownloadFlowStore } from '@/stores/useDownloadFlowStore';
import AuthModal from '@/components/auth/AuthModal';

/**
 * Download Flow Authentication Modal Component
 * 
 * This component automatically integrates with the download flow store to show
 * the authentication modal when needed and resume the download flow after
 * successful authentication.
 */
const DownloadFlowAuthModal: React.FC = () => {
  const {
    modalState,
    currentSession,
    hideAuthModal,
  } = useDownloadFlowStore();

  // Only render if auth modal should be visible and we have a download session
  if (!modalState.isAuthModalVisible || !currentSession) {
    return null;
  }

  return (
    <AuthModal
      isOpen={modalState.isAuthModalVisible}
      onClose={hideAuthModal}
      // Pass download session details to the auth modal
      sequenceId={currentSession.sequenceId}
      sequenceTitle={currentSession.sequenceTitle}
      sequenceArtist={currentSession.sequenceArtist}
      isFree={currentSession.isFree}
      price={currentSession.price}
      isOwner={currentSession.isOwner}
    />
  );
};

export default DownloadFlowAuthModal; 